export const VARIANTS = {
  CRITICAL: 'critical',
  PRIMARY: 'primary',
  TERTIARY: 'tertiary',
  SECONDARY: 'secondary',
  SYMBOL: 'symbol',
};
